declare let PositiveFeedback: any;

declare global {
  interface Window {
    PositiveFeedback: any;
  }
}

export function extendPositiveFeedback() {
  if (lib.comsuntexsymbolsPositiveFeedback) {
    window.PositiveFeedback = lib.comsuntexsymbolsPositiveFeedback;

    const comsuntexsymbolsPositiveFeedback_constructor =
      lib.comsuntexsymbolsPositiveFeedback;
    const comsuntexsymbolsPositiveFeedback_prototype =
      lib.comsuntexsymbolsPositiveFeedback.prototype;

    lib.comsuntexsymbolsPositiveFeedback = function () {
      this._oldConstructor = comsuntexsymbolsPositiveFeedback_constructor;
      this._oldConstructor();

      UIUtil.hide(this);
      UIUtil.scaleTo(UIUtil.find(this, 'text'), 0.1);
    };
    lib.comsuntexsymbolsPositiveFeedback.prototype =
      comsuntexsymbolsPositiveFeedback_prototype;

    const p = lib.comsuntexsymbolsPositiveFeedback.prototype;

    p.correctMin = 1;
    p.correctMax = 7;
    p.incorrectMin = 20;
    p.incorrectMax = 23;

    p.showCorrect = function () {
      UIUtil.setFrame(
        UIUtil.find(this, 'text'),
        Chance.semiRandomInt(this.correctMin, this.correctMax),
      );
      UIUtil.setFrame(UIUtil.find(this, 'bg'), Chance.randomInt(1, 7));
      this.show();
    };

    p.showIncorrect = function () {
      UIUtil.setFrame(
        UIUtil.find(this, 'text'),
        Chance.semiRandomInt(this.incorrectMin, this.incorrectMax),
      );
      UIUtil.setFrame(UIUtil.find(this, 'bg'), Chance.randomInt(20, 27));
      this.show();
    };

    p.show = function () {
      UIUtil.show(this, 800, 'strongOut');
      UIUtil.scaleTo(UIUtil.find(this, 'text'), 1.0, 800, 'strongOut');
      UIUtil.cancelDelay(PositiveFeedback.hide);
      UIUtil.delay(PositiveFeedback.hide, 1600, [this]);
    };

    PositiveFeedback.hide = function (pf) {
      UIUtil.scaleTo(UIUtil.find(pf, 'text'), 0.1, 800, 'strongOut');
      UIUtil.hide(pf, 800, 'strongOut');
    };
  }
}
